import React, { useEffect, useRef, useState } from "react";
import "../../components/Form/Form.scss";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getQuiz, mapQuestionsToQuiz } from "../../services/QuizService";
import { getQue } from "../../services/QuizService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import "./QuizModal.scss";
import { Toast } from "primereact/toast";

function QuizeViewModal({ onClose, selectedItem, isQuestionMapped }) {
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const toast = useRef(null);
  const [questions, setQuestions] = useState([]);
  useEffect(() => {
  const fetchQuestions = async () => {
    try {
      const response = await getQue(selectedItem.id, isQuestionMapped);
      const questionArray = Array.isArray(response)
        ? response
        : response?.data || [];
      setQuestions([...questionArray]);
      if (isQuestionMapped) {
        setSelectedQuestions(questionArray);
      } else {
        const preSelected = questionArray.filter(q =>
          selectedItem.question_ids?.includes(q.id)
        );
        setSelectedQuestions(preSelected);
      }
    } catch (error) {
      console.error("Error fetching Questions:", error);
    }
  };
  if (selectedItem?.id) {
    fetchQuestions();
  }
  }, [selectedItem, isQuestionMapped]);
  const onSelectionChange = (e) => {
    const maxQuestions = selectedItem?.total_questions || 0;
    if (e.value.length <= maxQuestions) {
      setSelectedQuestions(e.value);
    } else {
      toast.current?.show({
        severity: "warn",
        summary: "Limit Reached",
        detail: `You can only select up to ${maxQuestions} questions.`,
        life: 3000,
      });
    }
  };
  const handlePublish = async () => {
    if (selectedQuestions.length === 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one question.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: "Do you want to map these questions to the quiz?",
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        try {
          const questionIds = selectedQuestions.map((q) => q.id);
          await mapQuestionsToQuiz(selectedItem.id, questionIds);
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: "Questions successfully mapped to the quiz!",
            life: 3000,
          });
          onClose();
        } catch (error) {
          console.error("Error mapping questions to quiz:", error);
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to map questions to the quiz.",
            life: 3000,
          });
        }
      },
      reject: () => {
        console.log("Mapping canceled");
      },
    });
  };
  return (
    <div className="modal-container">
      <h2 style={{ textAlign: "left", marginLeft: "10px" }}>Quiz Details</h2>
      <div className="grid-container">
        <div className="column">
          <label>Quiz Title</label>
          <div className="value-box">
            {selectedItem?.QuizTranslations?.title || "-"}
          </div>
        </div>
        <div className="column">
          <label>Quiz Type</label>
          <div className="value-box">{selectedItem?.quiz_type || "-"}</div>
        </div>
        <div className="column">
          <label>Module</label>
          <div className="value-box">{selectedItem?.module?.title || "-"}</div>
        </div>
        <div className="column">
          <label>Topic</label>
          <div className="value-box">{selectedItem?.topic?.title || "-"}</div>
        </div>
        <div className="column">
          <label>Roles</label>
          <div className="value-box">{selectedItem?.roles || "-"}</div>
        </div>
      </div>
      <Toast ref={toast} />
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ textAlign: "left", marginLeft: "10px" }}>
          Quiz Questions
        </h2>
        <DataTable
          className="table-viewport custom-tooltip"
          resizableColumns
          value={questions || []}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="510px"
          selection={selectedQuestions}
          onSelectionChange={onSelectionChange}
        >
          {!isQuestionMapped && (<Column
              selectionMode="multiple"
              header="Select"
              frozen
              alignFrozen="center"
              style={{ textAlign: "center" }}
              bodyStyle={{ textAlign: "center", justifyContent: "center" }}
          />)}
          <Column
            header="Question"
            body={(rowData) => rowData.QuestionTranslations?.[0]?.text || "-"}
          />
        </DataTable>
      </div>
      <div className="form-actions">
      {!isQuestionMapped &&(<><Button
              label="Update"
              icon="pi pi-check"
              className="p-button-success"
              style={{ backgroundColor: "#1d2965", marginRight: "10px" }}
              onClick={handlePublish}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary mt-3"
              style={{ backgroundColor: "rgba(29, 41, 101, 0.5)" }}
              onClick={onClose}
        /></>)}
      </div>
      <style jsx>{`
        .modal-container {
          padding: 20px;
          background: white;
          text-align: center;
        }
        .grid-container {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 10px;
          margin: 20px 0;
        }
        .column {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .column label {
          font-weight: bold;
          margin-bottom: 5px;
        }
        .value-box {
          width: 150px;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 5px;
          background: #f9f9f9;
          text-align: center;
        }
      `}</style>
      <ConfirmDialog />
    </div>
  );
}

export default QuizeViewModal;